import React from 'react';
import { faMagic } from '@fortawesome/free-solid-svg-icons';
import { SelectionCard } from './SelectionCard';

interface SmartCreateSelectionCardProps {
  onClick: () => void;
}

export const SmartCreateSelectionCard = ({ onClick }: SmartCreateSelectionCardProps) => {
  return (
    <SelectionCard
      title="Smart Create"
      description="Give a topic or upload a PDF—AI drafts it for you."
      icon={faMagic}
      iconColor="#8e44ad"
      iconBackgroundColor="#e8d5f0"
      onClick={onClick}
    />
  );
};
